<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="ded"><i>Dedication</i></p>
<p class="ded1">Dedicated to those always at sea,<br/>who found their final resting place in the dark depths of the Atlantic</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?5c324f4c